import { ProductServiceInterface } from './interface';
import { ProductService } from './ProductService';

/**
 *  Фабрика сервиса генерации даты продукта с замороженными сущностями
 */
export const productService: { (): ProductServiceInterface } = () => new ProductService();
